/**
 * QL-375 — the one mapping from a mandate verdict to a badge, used by the
 * goal / portfolio panel and the per-portfolio summary alike.
 */

import type { MandatePortfolioVerdict } from "@repo/shared/types";
import { Badge } from "@/components/ui/badge";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./mandate-verdict-badge.i18n";

type Props = {
  effective: MandatePortfolioVerdict["effective"];
  notEvaluableReason: MandatePortfolioVerdict["notEvaluableReason"];
  /** The placement that does not gate at the collection's block level. */
  informational?: boolean;
};

export function MandateVerdictBadge({ effective, notEvaluableReason, informational }: Props) {
  const t = useT(T);
  if (informational) return <Badge variant="secondary">{t.statusInformational}</Badge>;
  if (notEvaluableReason) return <Badge variant="warning">{t.statusNotEvaluable}</Badge>;
  switch (effective) {
    case "ok":
      return <Badge variant="success">{t.statusOk}</Badge>;
    case "accepted":
      return <Badge variant="warning">{t.statusAccepted}</Badge>;
    case "not_accepted":
      return <Badge variant="destructive">{t.statusNotAccepted}</Badge>;
    case "deviation":
      return <Badge variant="destructive">{t.statusDeviation}</Badge>;
    default:
      return null;
  }
}
